import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { useTranslation } from 'react-i18next';
import { TabEnum } from '../../../../../../models/enums/tab-enum';
import { useRootStore } from '../../../../../../providers/root-store-provider';
import { SkeletonDashboardProfitChart } from '../../../../../../components/app/skeleton/dashboard/trades/protif-chart/skeleton-dashboard-profit-chart';
import { BaseLineChart } from '../../../../../../components/app/chart/base/line/base-line-chart';
import { NoData } from '../../../../../../components/app/no-data/no-data';

type DashboardProfitChartAbsoluteType = {
    toggleFullScreen: () => void;
    isFullScreen: boolean;
};

export const DashboardTradesProfitChartAbsolute: React.FC<DashboardProfitChartAbsoluteType> = observer(
    ({ toggleFullScreen, isFullScreen }: DashboardProfitChartAbsoluteType) => {
        const { t } = useTranslation();
        const rootStore = useRootStore();
        const { statisticStore, portfolioStore } = rootStore;
        const { profitStore } = statisticStore;
        const hasChartData = statisticStore.profitStore.absoluteProfits.some((chart) => chart.data.length > 0);

        if (profitStore.loading || portfolioStore.selectedPortfolio.isRecalculating) {
            return <SkeletonDashboardProfitChart />;
        }

        if (!hasChartData) {
            return <NoData>{t('layout.tables.noDetailedData')}</NoData>;
        }

        return (
            <BaseLineChart
                tab={TabEnum.Absolute}
                dateFormat={statisticStore.chartDateFormat}
                labelDateFormat={process.env.NEXT_PUBLIC_DATE_FORMAT as string}
                chartData={statisticStore.profitStore.absoluteProfits}
                unit={rootStore.portfolioStore.selectedPortfolio.portfolioHistoryCurrencyCode || ''}
                filter={profitStore.filter}
                onChange={(id) => profitStore.filterSelected(id)}
                toggleFullScreen={toggleFullScreen}
                isFullScreen={isFullScreen}
            />
        );
    },
);
